import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const scanRoutes: RouteRecordRaw[] = [
  {
    path: '/scans',
    name: ROUTES.SCANS,
    component: () => import('@/modules/scans/views/ScansIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.SCANS_VIEW }
  },
  {
    path: '/scans/pass/:id',
    name: ROUTES.SCANS_BY_PASS,
    component: () => import('@/modules/scans/views/ScansIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.SCANS_VIEW }
  },
  {
    path: '/scans/card-pass/:cardPassId',
    name: ROUTES.SCANS_BY_CARD_PASS,
    component: () => import('@/modules/scans/views/ScansIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.SCANS_VIEW }
  },
  {
    path: '/reversed-scans',
    name: ROUTES.REVERSED_SCANS,
    component: () => import('@/modules/scans/views/ReversedScans.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.REVERSED_SCANS_VIEW }
  },
  {
    path: '/reversed-scans/pass/:id',
    name: ROUTES.REVERSED_SCANS_BY_PASS,
    component: () => import('@/modules/scans/views/ReversedScans.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.REVERSED_SCANS_VIEW }
  },
  {
    path: '/reversed-scans/card_pass/:cardPassId',
    name: ROUTES.REVERSED_SCANS_BY_CARD_PASS,
    component: () => import('@/modules/scans/views/ReversedScans.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.REVERSED_SCANS_VIEW }
  }
]
